import {
  BulkAssignUsersParams,
  BulkAssignUsersResponse,
  Region,
  RegionClinicPatchParams,
  RegionCreate,
  RegionQueryParams,
  RegionUpdate,
  RegionUsersPatchParams
} from "services/types/regions.type";

import { formatValidQueryParamUrlCommaSeparated } from "../utils/common";
import { emptySplitApi } from "./empty-split-api";

export const regionsApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    getRegionsList: builder.query<Region[], RegionQueryParams>({
      query: ({ limit = 300, offset = 0, query = "{*}", ...params }) => ({
        url: `/regions/?${formatValidQueryParamUrlCommaSeparated({
          limit,
          offset,
          query,
          ...params
        })}`
      }),
      providesTags: ["Regions"]
    }),
    getRegion: builder.query<Region, { regionId: number; query?: string }>({
      query: ({ regionId, query = "{*}" }) =>
        `/regions/${regionId}/?query=${query}`,
      providesTags: ["Regions"]
    }),
    createRegion: builder.mutation<Region, RegionCreate>({
      query: (body) => ({
        url: "/regions/",
        method: "POST",
        body: body
      }),
      invalidatesTags: ["Regions"]
    }),
    updateRegion: builder.mutation<Region, RegionUpdate>({
      query: ({ id, ...body }) => ({
        url: `/regions/${id}/`,
        method: "PATCH",
        body: body
      }),
      invalidatesTags: ["Regions"]
    }),
    deleteRegion: builder.mutation<Region, { id: number }>({
      query: ({ id }) => ({
        url: `/regions/${id}/`,
        method: "DELETE"
      }),
      invalidatesTags: ["Regions"]
    }),
    updateClinicsInRegion: builder.mutation<
      Region,
      RegionClinicPatchParams<number>
    >({
      query: ({ id, ...body }) => ({
        url: `/regions/${id}/update-clinics/`,
        method: "PATCH",
        body: body
      }),
      invalidatesTags: ["Regions"]
    }),

    updateUsersInRegion: builder.mutation<Region, RegionUsersPatchParams>({
      query: ({ id, ...body }) => ({
        url: `/regions/${id}/update-users/`,
        method: "PATCH",
        body: body
      }),
      invalidatesTags: ["Regions"]
    }),

    bulkAssignUsersToRegions: builder.mutation<
      BulkAssignUsersResponse,
      BulkAssignUsersParams
    >({
      query: (body) => ({
        url: "/regions/bulk-assign-users/",
        method: "POST",
        body
      }),
      invalidatesTags: ["Regions", "StaffRegions"]
    })
  })
});

export const {
  useGetRegionsListQuery,
  useCreateRegionMutation,
  useUpdateRegionMutation,
  useGetRegionQuery,
  useUpdateClinicsInRegionMutation,
  useUpdateUsersInRegionMutation,
  useDeleteRegionMutation,
  useBulkAssignUsersToRegionsMutation
} = regionsApi;
